// assets
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
// icons
const icons = {
    SubscriptionsOutlinedIcon,
    HelpCenterOutlinedIcon,
    SettingsOutlinedIcon
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
    id: 'support',
    title: 'Support',
    type: 'group',
    subscriptionRequired: ['unknown','basic','standard','premium','enterprise','admin'],
    children: [
        {
            id: 'settings',
            title: 'Settings',
            type: 'item',
            url: '/settings',
            icon: icons.SettingsOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
        {
            id: 'subscriptions',
            title: 'Manage Subscription',
            type: 'item',
            url: '/subscriptions',
            icon: icons.SubscriptionsOutlinedIcon,
            showInShopifyApp: true,
        },
        {
            id: 'documentation',
            title: 'Documentation',
            type: 'item',
            url: process.env.REACT_APP_DOCS_URL,
            icon: icons.HelpCenterOutlinedIcon,
            external: true,
            target: true,
            showInShopifyApp: true,
        }
    ]
};

export default support;
